<template>
  <section>
    <v-row class="my-0">
      <v-col cols="12" md="6">
        <v-card flat>
          <v-card-title class="py-2">{{ event.EventTranslationName }}</v-card-title>
          <v-card-text>
            <div>{{ `${event.Street} ${event.Nr}` }}</div>
            <div>{{ `${event.PostalCode} ${event.City}` }}</div>
            <div>{{ event.Telephone }}</div>
            <div>{{ event.Email }}</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card flat>
          <v-card-title class="py-2">{{ $translate('PICKUP_DATE_TIME') }}</v-card-title>
          <v-card-text>
            <div>{{ `${userInfo.firstName} ${userInfo.lastName}` }}</div>
            <div>{{ `${userInfo.phoneNo}` }}</div>
            <div class="mb-2">{{ `${userInfo.email}` }}</div>
            <div class="font-weight-bold">
              {{ startDate }} {{ `${startTime}-${endTime}` }}
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  name: 'SubscriptionOverviewPickUp',
  components: {},
  props: {
    event: Object,
    userInfo: Object,
    startDate: String,
    startTime: String,
    endTime: String,
  },
  data() {
    return {
    };
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
</style>
